import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const beliefs = () => {

  document.fonts.ready.then(() => {

    const section = document.querySelector('.beliefs')
    const items = document.querySelectorAll('.beliefs__item')
    const gapTop = window.innerWidth > 1025 ? '-7vw' : '-8vw'
    const gapBottom = window.innerWidth > 1025 ? '14.5vw' : '18vw'

    if (!section || window.innerWidth < 650) return

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        pin: true,
        start: 'center center',
        end: `+=${ items.length * 1800 }`,
        scrub: 1,
      }
    })
    items.forEach((item, i) => {
      const lines = item.querySelectorAll('.line')
      const words = item.querySelectorAll('.word')
      const text = item.querySelector('.beliefs__text')

      if (i == 0) {
        tl.to(lines[0], { duration: 0.8, clipPath: 'inset(0 0 50% 0)', y: gapTop, opacity: 0.25, ease: 'power2.inOut' })
        tl.to(lines[1], { duration: 0.8, clipPath: 'inset(50% 0 0 0)', y: gapBottom, opacity: 0.25, ease: 'power2.inOut' }, '<')
        tl.to(text, { duration: 1, y: '13vw', opacity: 0 }, '<')
      } else if (i == items.length - 1) {
        tl.to(words, { duration: 1, yPercent: 0, y: 0, stagger: 0.04, overwrite: true, ease: 'power3.inOut' }, '<')
        tl.to(text, { duration: 1, opacity: 1 }, '-=0.9')
        tl.to(items[i - 1], { duration: 0.5, opacity: 0 }, '-=0.9')
      } else {
        tl.to(words, { duration: 1, yPercent: 0, y: 0, stagger: 0.04, overwrite: true, ease: 'power3.inOut' }, '<')
        tl.to(text, { duration: 1, opacity: 1 }, '-=0.9')
        tl.to(items[i - 1], { duration: 1, opacity: 0 }, '-=0.9')
        tl.to(lines[0], { duration: 0.8, clipPath: 'inset(0 0 50% 0)', y: gapTop, opacity: 0.25, ease: 'power2.inOut' }, '-=0.5')
        tl.to(lines[1], { duration: 0.8, clipPath: 'inset(50% 0 0 0)', y: gapBottom, opacity: 0.25, ease: 'power2.inOut' }, '<')
        tl.to(text, { duration: 0.75, y: '13vw', opacity: 0, ease: 'power2.inOut' }, '<')
      }
    })

  })
  
}

export default () => { }